import React, { useState } from "react";
import "./TestingPage.css";
import { Link } from "react-router-dom";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "react-pdf/dist/esm/Page/TextLayer.css";

import samplePDF from "../../assets/images/pdfs/mentors-list-it-department.pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const TestingPage = () => {
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <div
      className="container accreditationsDetails-section"
      data-aos="fade-up"
      data-aos-delay="100"
    >
      {/* Title */}
      <div className="row">
        <div className="col-lg-4">
          <div className="title-box">
            <h2>Testing Page</h2>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        {/* Side Navigation */}
        <div className="col-lg-3">
          <div className="sideNav-box">
            <h2>Navigation</h2>
            <ul>
              <li>
                <Link to="#">A.I.C.T.E.</Link>
              </li>
              <li>
                <Link to="#">N.B.A.</Link>
              </li>
              <li>
                <Link to="#">N.A.A.C.</Link>
              </li>
              <li>
                <Link to="#">N.I.R.F.</Link>
              </li>
              <li>
                <Link to="#">U.G.C.</Link>
              </li>
              <li>
                <Link to="#">A.I.S.H.E.</Link>
              </li>
              <li>
                <Link to="#">I.Q.A.C.</Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Tabs */}
        <div className="col-lg-6">
          <h2>Tabs</h2>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="home-tab"
                data-bs-toggle="tab"
                data-bs-target="#home"
                type="button"
                role="tab"
              >
                Home
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#profile"
                type="button"
                role="tab"
              >
                Profile
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="contact-tab"
                data-bs-toggle="tab"
                data-bs-target="#contact"
                type="button"
                role="tab"
              >
                Contact
              </button>
            </li>
          </ul>

          <div className="tab-content p-4 shadow-lg rounded-4 bg-white mt-3">
            <div
              className="tab-pane fade show active"
              id="home"
              role="tabpanel"
            >
              <h4>Welcome Home</h4>
              <p>
                This is a beautiful Bootstrap 5 tab layout with smooth design.
              </p>
            </div>
            <div className="tab-pane fade" id="profile" role="tabpanel">
              <h4>Your Profile</h4>
              <p>You can add images, forms, and more here.</p>
            </div>
            <div className="tab-pane fade" id="contact" role="tabpanel">
              <h4>Contact Us</h4>
              <p>
                This area can hold your contact details, map, or social links.
              </p>
            </div>
          </div>
        </div>

        {/* Accordion */}
        <div className="col-lg-3">
          <h2>Accordion</h2>
          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                >
                  Open PDF Viewer
                </button>
              </h2>
              <div
                id="collapseOne"
                className="accordion-collapse collapse show"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <h2>Accordion Body</h2>
                  <p>This is inside the accordion body content.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PDF Viewer */}
        <div className="col-lg-6 mt-4">
          <h2>PDF Viewer</h2>
          <div className="pdfs-box mt-3 shadow-lg p-3 bg-white rounded">
            <Document file={samplePDF} onLoadSuccess={onDocumentLoadSuccess}>
              {Array.from(new Array(numPages), (el, index) => (
                <Page key={`page_${index + 1}`} pageNumber={index + 1} />
              ))}
            </Document>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestingPage;
